module.exports = __webpack_public_path__ + "5ab52be3702ac6ec56525d3f6e9fdc5a.png";


//////////////////
// WEBPACK FOOTER
// ../assets/neuron-simulation.png
// module id = 520
// module chunks = 0